import { render, staticRenderFns } from "./sdk.vue?vue&type=template&id=41fc5012&scoped=true&"
import script from "./sdk.vue?vue&type=script&lang=js&"
export * from "./sdk.vue?vue&type=script&lang=js&"
import style0 from "./sdk.vue?vue&type=style&index=0&id=41fc5012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc5012",
  null
  
)

export default component.exports